import React from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, View, Text, ScrollView } from 'react-native';
import BookingFlowFooter from './BookingFlowFooter';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { ExclamationIcon } from "../../ui";
import {
    Button,
    ButtonTypes,
} from '../../components';
class CustomiseWarning extends React.PureComponent<any, any> {

    public render() {
        const { t } = this.props;
        return (
            <View style={{flex: 1}}>
                <View style={styles.warningContainer}>
                    <View style={styles.exclamationContainer}>
                        <ExclamationIcon size={defaultScale(40)} fontWeight={'bold'} />
                    </View>
                    <Text style={styles.warningText}>{t('warning')}</Text>
                    <View style={styles.warningExplanationContainer}>
                        <Text style={styles.warningExplanation}>
                            {t('customiseWarning')}</Text>
                    </View>
                </View>
                {!this.props.hideButtons &&
                <BookingFlowFooter>
                    <View style={styles.buttonsContainer}>
                        <Button
                            title={t('customise')}
                            onPress={this.props.personaliseWorkout}
                            buttonType={ButtonTypes.OUTLINE}
                            containerStyle={styles.leftButton}
                        />
                        <Button
                            title={t('dontCustomise')}
                            onPress={this.props.dontPersonalise}
                            fontColor={Theme.WHITE}
                            containerStyle={styles.rightButton}
                        />
                    </View>
                </BookingFlowFooter>}
            </View>
        );
    }
}

const styles = StyleSheet.create({
    warningContainer: {
        flex: 1,
        justifyContent: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        width: '100%'
    },
    footer: {
        alignContent: 'flex-end',
        justifyContent: 'flex-end',
        flexDirection: 'row',
        alignSelf: 'center',
    },
    exclamationContainer: {
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: defaultScale(15),
        marginBottom: defaultScale(20)
    },
    warningText: {
        ...Theme.textStyle.heading,
        alignSelf: 'center',
        color: Theme.BLACK,
        marginBottom: defaultScale(20)
    },
    warningExplanation: {
        ...Theme.textStyle.heading,
        alignSelf: 'center',
        textAlign: 'center'
    },
    warningExplanationContainer: {
        width: '70%',
        alignSelf: 'center',
    },
    buttonsContainer: {
        flexDirection: 'row',
    },
    leftButton: {
        flex: 1,
        flexBasis: 0,
        marginRight: defaultScale(5),
    },
    rightButton: {
        flex: 1,
        flexBasis: 0,
    },
});

export default translate(['bookings'], { wait: true })(CustomiseWarning);
